module.exports = __webpack_public_path__ + "static/media/mobile.cde69dd2.svg";